import React, { useState } from 'react'
import {connect} from 'react-redux'
import {postProcedura, getTemplateExcelProcedury, uploadFileProcedury, getProcedures} from 'actions/procedureDefActions';
import {getProcedureArchive} from 'actions/ProcedurePricingActions'
import Select from "react-select";
import "react-datepicker/dist/react-datepicker.css";
import {registerLocale} from "react-datepicker";
import pl from 'date-fns/locale/pl';
import moment from 'moment';
import SendFile from 'components/common/sendFile'
import Spinner from 'components/common/Spinner';
import ArchiveButton from "../../../components/medicalProceduresComponents/ArchiveButton";
import ProcedureArchiveTable from 'components/medicalProceduresComponents/ProcedureArchiveTable'
import DeleteButton from "../../../components/medicalProceduresComponents/DeleteButton";
import {getCurrentUser} from 'actions/userActions';


// reactstrap components
import {
    Row, Col,
    Button,
    Input,
    Label,
    FormGroup,
    Form,
    Modal,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
} from "reactstrap";
import ReactDatetime from "react-datetime";
import {
    deleteProcedura
} from "../../../actions/procedureDefActions";

const Procedure = (props) => {
    registerLocale('pl', pl)
    const valueConvert = (val) => {
        let nr = Number(val).toFixed(2).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1 ').replace(".", ",")
        return nr === "NaN" ? " X " : nr
    }
    const {procedures, icd9, searchICD, opk507, postProcedura, 
        getTemplateExcelProcedury, uploadFileProcedury, errorFileMaterial, loadingFileMaterial, getProcedures,
        getProcedureArchive, procedure_archive, deleteProcedura, proceduresFilter,
        getCurrentUser, currentUser
    } = props
    const [formValues, setFormValues] = React.useState({
        icd_code_slow: ""
    })
    React.useEffect(()=>{
        getCurrentUser()
    },[])
    const [formValuesEdit, setFormValuesEdit] = React.useState({})
    const [idtoEdit, setIdEdit] = React.useState(null)
    const seIdelement = (elem) => {
        let temp = {}
        setIdEdit(elem.id, setFormValuesEdit(temp))
    }
    const [archiveModal, setArchiveModal] = useState(false)
    const toggleArchiveModal = () => {
        setArchiveModal(!archiveModal)
    }
    const showArchive = (id) => {
        getProcedureArchive(id)
        setArchiveModal(true)
    }
    const handleFieldChange = (e) => {
        const fieldValue = e.target.value;
        const fieldIndex = e.target.id

        setFormValues((prevState) => {
            const prevLoginValues = {...prevState};
            prevLoginValues[fieldIndex] = fieldValue;
            return prevLoginValues;
        });
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        if (moment(dateTo).isBefore(dateFrom)) {
            setAlertText("Sprawdź kolejność dat!", toggleModalMini());
            return 0
        }
        if (time_restricted && (dateFrom === '')) {
            setAlertText("Wybierając procedurę czasową musisz wybrać datę początkową!", toggleModalMini());
            return 0
        }
        if (nameIcd === '' || icdCode === '' || opkSelect507==="") {
            setAlertText("Wszystkie pola muszą być uzupełnione!", toggleModalMini());
            return 0
        }
        let dataToSend = {
            "name": nameIcd,
            "icd_code": icdCode,
            "icd_code_slow": opkSelect.label !=="wpisz początek"? opkSelect.label : "",
            "name_slow": opkSelectName.label !=="wpisz fragment nazwy (co najmniej 3 litery)"? opkSelectName.label:"",
            "personal_cost_value": 0,
            "material_cost_value": 0,
            "time_restricted": time_restricted,
            "year_from": null,
            "year_to": null,
            "month_from": null,
            "month_to": null,
            "opk_procedural": opkSelect507.value
        }
        if (time_restricted) {
            dataToSend.year_from = moment(dateFrom).format("YYYY");
            dataToSend.month_from = moment(dateFrom).format("MM");
            dataToSend.year_to = moment(dateTo).format("YYYY");
            dataToSend.month_to = moment(dateTo).format("MM");
        }

        postProcedura(dataToSend)
        setOpkSelect({value: "", label: "wpisz początek"})
        setOpkSelectName({value: "", label: "wpisz fragment nazwy (co najmniej 3 litery)"})
        setNameIcd("");
        setIcdCode('');
        // setDateFrom('');
        setDateFrom(moment(new Date()).format("YYYY-MM"));
        setDateTo("");
        setOpkSelect507({})
    }


    const [opkSelect, setOpkSelect] = React.useState({value: "", label: "wpisz początek"});
    const [opkSelectName, setOpkSelectName] = React.useState({
        value: "",
        label: "wpisz fragment nazwy (co najmniej 3 litery)"
    });
    React.useEffect(()=>{
       setIcdCode(opkSelectName.value)
        setNameIcd(opkSelectName.label)}
    ,[opkSelectName])
    const optionsOPK = []
    const optionsOPKName = []
    if (icd9) icd9.forEach(opk => {
        optionsOPK.push({value: opk.icd9_name, label: opk.icd9_code})
    })
    if (icd9) icd9.forEach(opk => {
        optionsOPKName.push({value: opk.icd9_code, label: opk.icd9_name})
    })
    const [opkSelect507, setOpkSelect507] = React.useState(null)
    const [opkSelect507Filter, setOpkSelect507Filter] = React.useState({label:"", value:""});

    React.useEffect(()=>{
        if(opkSelect507Filter.value !== "" &&  opkSelect507Filter.value !== 'all')proceduresFilter(opkSelect507Filter.value,search)
        else if(opkSelect507Filter.value==='all')proceduresFilter("",search)
        
    },[opkSelect507Filter])
    const [search, setSearch] = React.useState("")
    // React.useEffect(()=>{
    //     if(opkSelect507Filter.value !== "" &&  opkSelect507Filter.value !== 'all')proceduresFilter(opkSelect507Filter.value,search)
    //     else if(opkSelect507Filter.value==='all')proceduresFilter("",search)
    // },[search])
    const searchProcedures = () =>{
        if(opkSelect507Filter.value !== 'all')proceduresFilter(opkSelect507Filter.value,search)
        else if(opkSelect507Filter.value==='all')proceduresFilter("",search)
    }

    

    const optionsOpk507 = []
    if (opk507) Object.entries(opk507).map(([value, key], i) => {
        optionsOpk507.push({value: value, label: key})
    })
    const [time_restricted, setTime_restricted] = React.useState(true);

    const [dateFrom, setDateFrom] = React.useState("")
    const [dateTo, setDateTo] = React.useState("")
    const [icdCode, setIcdCode] = React.useState("")
    const [nameIcd, setNameIcd] = React.useState("")

    const [modalMini, setModalMini] = React.useState(false);
    const toggleModalMini = () => {
        setModalMini(!modalMini);
    };
    const [alertText, setAlertText] = React.useState("")
    const getTempalte = () => {
        getTemplateExcelProcedury()
    }
    const handleSubmitFile = (file) => {
        if(!file.file){console.log('brak pliku'); return 0}
        const formData = new FormData();
        formData.append(
            `file`,
            file.file );
        formData.append(
            `name`,
            file.name);
            uploadFileProcedury(formData)
    }
    const usePrevious = (value) => {
        const ref = React.useRef();
        React.useEffect(() => {
          ref.current = value;
        });
        return ref.current;
      }
    const prevCount = usePrevious(loadingFileMaterial)
    React.useEffect(()=>{
        if(loadingFileMaterial){setShowModal(true)}
        if(prevCount) getProcedures() },
    [loadingFileMaterial])

    const [ShowModal, setShowModal] = React.useState(false)
    const toggleModalMiniFile = () => {
        setShowModal(!ShowModal);
    };
    const searchOnEnter = (event) =>{
        if(event.key === "Enter") {
            if(opkSelect507Filter.value !== 'all')proceduresFilter(opkSelect507Filter.value,search)
            else if(opkSelect507Filter.value==='all')proceduresFilter("",search)
        }}


    // const changeName = (value) =>{

    // }

    // React.useEffect(()=>{
    //     getMaterials()
    // // eslint-disable-next-line
    // },[])
    return (
        <div className="content">
                <SendFile getTemplate={getTempalte} handleSubmitFile={handleSubmitFile} currentUser={currentUser}></SendFile><br/>
                <hr/><br/>

            <div>
                <Form className="settings-form okraglaczki nowaOkr" onSubmit={(e) => handleSubmit(e)}>
                    <Row>
                        <Col md="2" sm="14">

                            <FormGroup>
                                <label>{`${"Kod procedury (icd 9)"}`}</label>

                                {/* <Input type="select" name="icd_code_slow" id="icd_code_slow" value={formValues['icd_code_slow']} onChange={(e)=>handleFieldChange(e)}>
                        {icd9 ? icd9.map((el,i)=>{
                          return <option value={el.icd9_code}>{el.icd9_code}</option>

                        }):<option value={""}>wszystkie</option>}
                      </Input> */}
                                <Select
                                    className="react-select select-wycena"
                                    classNamePrefix="react-select"
                                    name="opkSelect"
                                    aria-label={'Wpisz początek'}
                                    value={opkSelect}
                                    onChange={(value) => {
                                        setOpkSelect(value, setOpkSelectName({value: value.label, label: value.value}))
                                    }}
                                    onInputChange={(value) => {
                                        searchICD(value, 'number')
                                    }}
                                    options={optionsOPK}
                                    placeholder="wybierz"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4" sm="12">
                            <FormGroup >
                                <label>{`${"Nazwa procedury (icd9)"}`}</label>
                                <Select 
                                    className="react-select select-wycena"
                                    classNamePrefix="react-select"
                                    name="opkSelect"
                                    aria-label={'Wpisz fragment nazwy'}
                                    value={opkSelectName}
                                    onChange={(value) => {
                                        setOpkSelectName(value, setOpkSelect({value: value.label, label: value.value}))
                                    }}
                                    onInputChange={(value) => {
                                        searchICD(value, 'name')
                                    }}
                                    options={optionsOPKName}
                                    placeholder="wybierz"
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3" sm="12">
                            <FormGroup>
                                <label htmlFor={'icd_code'}>{`${"Kod procedury wg świadczeniodawcy"}`}</label>
                                <Input
                                    className="border-input"
                                    placeholder={`${"kod"}`}
                                    type="text"
                                    id="icd_code"
                                    /*aria-label={'Wpisz kod procedury'}*/
                                    value={icdCode}
                                    onChange={(e) => {
                                        setIcdCode(e.target.value)
                                        if(e.target.value===opkSelect.label){
                                            setNameIcd(opkSelectName.label)
                                        }
                                        if(e.target.value===""){
                                            setNameIcd("")
                                        }

                                    }}
                                />

                            </FormGroup>
                        </Col>
                        <Col md="3" sm="12">
                            <FormGroup>
                                <label htmlFor={'name'}>{`${"Nazwa procedury wg świadczeniodawcy"}`}</label>
                                <Input
                                    className="border-input"
                                    type="text"
                                    /*aria-label={'Wpisz nazwę procedury'}*/
                                    placeholder={`${"nazwa"}`}
                                    id="name"
                                    value={nameIcd}
                                    onChange={(e) => {
                                        setNameIcd(e.target.value)
                                    }}

                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row >
                        <Col md="3" sm="12">
                            <FormGroup>
                                <label htmlFor={'opkSelect'}>{`${"Kod OPK proceduralnego"}`}</label>
                                <Select
                                    className="react-select select-wycena"
                                    classNamePrefix="react-select"
                                    name="opkSelect"
                                    value={opkSelect507}
                                    onChange={(value) => {
                                        setOpkSelect507(value)
                                    }}
                                    /*aria-label={'Wybierz kod OPK'}*/
                                    options={optionsOpk507}
                                    placeholder="wybierz"
                                    aria-label="wybierz"
                                />
                            </FormGroup>
                        </Col>
                        {/* <Col md='1'>
                            <FormGroup check style={{paddingTop: '12px'}} className="proceduryCheckBox">
                                <label>{`${""}`}</label><br></br>

                                <Label check>
                                    <Input type="checkbox" onChange={() => setTime_restricted(!time_restricted)}
                                           checked={time_restricted}/> <span className="form-check-sign"/> czasowa?
                                </Label>
                            </FormGroup>
                        </Col> */}
                        {time_restricted && <>
                            <Col md='2' sm='12'>
                                <FormGroup>
                                    <label>{`${"Data początkowa"}`}</label><br></br>
                                    <ReactDatetime
                                        inputProps={{
                                            className: "form-control",
                                            placeholder: "data początkowa",
                                            'aria-label': "data początkowa",
                                        }}
                                        dateFormat={"YYYY-MM"}
                                        timeFormat={false}
                                        locale="pl"
                                        onChange={(date) => {
                                            setDateFrom(date)
                                        }}
                                        value={dateFrom}
                                        className='dateSelectWycena'
                                    />


                                </FormGroup>
                            </Col>
                            {/* <Col md='2' sm='12'>
                                <FormGroup>
                                    <label>{`${"Data końcowa"}`}</label><br></br>
                                    <ReactDatetime
                                        inputProps={{
                                            className: "form-control",
                                            placeholder: "data końcowa",
                                        }}
                                        dateFormat={"YYYY-MM"}
                                        timeFormat={false}
                                        locale="pl"
                                        onChange={(date) => {
                                            setDateTo(date)
                                        }}
                                        value={dateTo}
                                    />
                                </FormGroup>
                            </Col> */}
                        </>}
                        <Col md="1">
                            <FormGroup style={{textAlign:"center"}}>
                                <label>{`${"Dodaj"}`}</label><br/>
                                <Button style={{width:"60px"}}
                                    className="btn-round btn m-0"
                                    color="wycena"
                                    type="submit"
                                    outline
                                    disabled={currentUser && currentUser.company === null}
                                    aria-label={'Dodaj'}

                                >
                                     <i className='nc-icon nc-simple-add'></i>
                                    {/* <i className="far fa-plus-square fa-2x"  ></i> */}
                                </Button>
                            </FormGroup>
                        </Col>
                    </Row>

                    {/*<Col md="1" >
                    <FormGroup>
                    <label>{`${"Dodaj"}`}</label><br></br>

                    <Button size='sm' style={{backgroundColor:"whitesmoke"}} type="submit"><i  className={'nc-icon nc-simple-add '} style={{color: 'green', cursor:'pointer', fontSize:"20px"}} /></Button>

                    </FormGroup> */}
                    {/* </Col> */}


                </Form>
            </div>
            <hr/>
            <br/>
            {/* Filtry */}
            <Row className="settings-form okraglaczki nowaOkr">
                <Col md="3" sm="12">
                    <FormGroup>
                        <label>{`${"Filtruj po kodzie OPK proceduralnego:"}`}</label>
                        <Select
                            className="react-select select-wycena"
                            classNamePrefix="react-select"
                            name="opkSelect"
                            value={opkSelect507Filter}
                            onChange={(value) => {
                                setOpkSelect507Filter(value)
                                console.log(opkSelect507Filter)
                            }}
                            aria-label={'Filtruj po kodzie OPK proceduralnego'}
                            options={[{value:"all",label:"Wszystkie"},...optionsOpk507]}
                            placeholder="wybierz"
                        />
                    </FormGroup>
                </Col>
                <Col md="3" sm="12">
                <label>{`${"Wpisz fragment i kliknij ikonę lub enter:"}`}</label>
                    <InputGroup className="" style={{}}>
                    <Input  defaultValue="" placeholder="Wyszukaj..." aria-label="Wyszukaj..." onKeyUp={searchOnEnter} type="text" style={{backgroundColor:"white", border:"1px solid rgba(0, 0, 0, 0.1)", borderRight:"none"}} value={search} onChange={(e)=>{setSearch(e.target.value)}}/>
                        <InputGroupAddon addonType="append" >
                            <InputGroupText style={{borderTopRightRadius:"30px", borderBottomRightRadius:"30px", border:"1px solid rgba(0, 0, 0, 0.1)", borderLeft:"none"}}>
                                <i className="nc-icon nc-zoom-split searchIcon" style={{cursor:"pointer"}} onClick={(e)=>{searchProcedures()}} />
                            </InputGroupText>
                        </InputGroupAddon>
                    </InputGroup>
                        </Col>
                </Row>
                
            <table className='table table-border tableWycena'>
                <thead className=''>
                <tr className=''>
                    <th className="headerColor">Kod procedury <br></br>(wg ICD-9)</th>
                    <th className="headerColor">Nazwa procedury <br></br>(wg IC-D9)</th>
                    <th className="headerColor">Kod procedury <br></br>(wg świadczeniodawcy)</th>
                    <th className="headerColor">Nazwa procedury<br></br> (wg świadczeniodawcy)</th>
                    <th className="headerColor">Numer OPK</th>
                    <th className="headerColor">Daty obowiązywania</th>
                    <th className="headerColor">Opcje</th>
                </tr>
                </thead>
                <tbody>
                {procedures && procedures.map((elem) => {
                    return <>
                        {idtoEdit !== elem.id ? <tr>
                            <td>{elem.icd_code_slow}</td>
                            <td>{elem.name_slow}</td>
                            <td>{elem.icd_code}</td>
                            <td>{elem.name}</td>
                            {/* <td>{opk507!==null&&opk507.hasOwnProperty(elem.opk_procedural)? opk507[elem.opk_procedural]:""}</td> */}
                            <td>{elem.opk_name_number}</td>

                            {/* <td>{elem.time_restricted === false ? "NIE" : <>{elem.month_from}.{elem.year_from} -
                                {elem.month_to}.{elem.year_to}</>}</td> */}
                            <td>{<>{elem.year_from !==1900 ? <>od {elem.month_from}.{elem.year_from} </>:""} 
                            {elem.year_to !== 2100?<>do {elem.month_to}.{elem.year_to}</>:""}</>}</td>
                            <td className={elem.calculated?"rightAlignCell":"text-center"}>
                                <ArchiveButton idx={elem.id} elem={elem} showArchive={showArchive}/> 
                                {elem.calculated && <DeleteButton idx = {elem.id}
                                id={elem.id}
                                deleteFunc={deleteProcedura}
                                text={"wybraną procedurę?"}/>}
                            </td>
                            {/* {idtoEdit !==elem.id ? <td onClick={()=>{seIdelement(elem)}}>Edytuj</td>:<td>
                    <span style={{marginRight:"5px", cursor:"pointer"}} onClick={()=>{setIdEdit(null)}}>
                    Anuluj</span>&nbsp;&nbsp;<span style={{marginLeft:"5px"}}>OK</span></td>} */}
                        </tr> : <tr></tr>
                            // <tr>
                            //     <td>
                            //         <Input
                            //             className="border-input"
                            //             type="text"
                            //             id="procedurestaff_opk_edit"
                            //             value={formValuesEdit['procedurestaff_opk_edit']}
                            //             onChange={(e)=>{}}
                            //         />
                            //     </td>
                            //     <td>
                            //         <Input
                            //             className="border-input"
                            //             type="text"
                            //             id="staff_type_edit"
                            //             value={formValuesEdit['staff_type_edit']}
                            //             onChange={(e)=>{}}

                            //         /></td>
                            //     <td><Input
                            //             className="border-input"
                            //             type="text"
                            //             id="rate_hour_edit"
                            //             value={formValuesEdit['rate_hour_edit']}
                            //             onChange={(e)=>{}}

                            //         /></td>
                            //     <td><Input
                            //             className="border-input"
                            //             type="text"
                            //             id="rate_min_edit"
                            //             value={formValuesEdit['rate_min_edit']}
                            //             onChange={(e)=>{}}

                            //         /></td>
                            //     <td className='rightAlignCell'><Input
                            //             className="border-input"
                            //             type="text"
                            //             id="rate_proc_edit"
                            //             value={formValuesEdit['rate_proc_edit']}
                            //             onChange={(e)=>{}}

                            //         /></td>
                            //     <td><span className="editButtonMat" onClick={()=>{setIdEdit(null)}}>Anuluj</span><span style={{cursor:"pointer"}}>OK</span></td>
                            //     </tr>
                        }

                    </>
                })}
                </tbody>
            </table>

            <Modal
                className="modal-sm"
                modalClassName="modal-primary"
                isOpen={modalMini}
                toggle={toggleModalMini}
            >
                <div className="modal-header justify-content-center">
                    <div className="modal-profile ml-auto mr-auto">
                        <i className="nc-icon nc-bulb-63"/>
                    </div>
                </div>
                <div className="modal-body">
                    <p>{alertText}</p>
                </div>
                <div className="modal-footer">
                        <Button
                            className='btn-link'
                            color="wycena"
                            data-dismiss="modal"
                            type="button"
                            onClick={toggleModalMini}
                        >
                            Zamknij
                        </Button>
                </div>
            </Modal>
            <Modal
             className="modal-sm"
             modalClassName="modal-primary"
             isOpen={ShowModal}
             toggle={toggleModalMiniFile}
             >
                 <div className="modal-header justify-content-center">
                    <div className="modal-profile ml-auto mr-auto">
                        <i className="nc-icon nc-bulb-63"/>
                    </div>
                </div>
                <div className="modal-body">
                    <p style={{textAlign:"center"}}>{loadingFileMaterial? <><Spinner/></>:<>
                    {errorFileMaterial ?<>Wystąpił błąd, sprawdź wprowadzane dane i spróbuj ponownie.</>:<>Pomyślnie zaimportowano dane!</>}
                    </>}</p>
                </div>
                <div className="modal-footer">
                        <Button
                            className='btn-link'
                            color="wycena"
                            data-dismiss="modal"
                            type="button"
                            onClick={e => {
                                toggleModalMiniFile();
                            }}>
                            Zamknij
                        </Button>
                </div>
            </Modal>
            <Modal
                size='xl'
                modalClassName="modal-primary"
                isOpen={archiveModal}
                toggle={toggleArchiveModal}
                >
                 <div className="modal-header justify-content-center">
                    <div className="modal-profile ml-auto mr-auto">
                        <i className="far fa-file-archive"/> 
                    </div>
                </div>
                <div className="modal-body">
                    <ProcedureArchiveTable procedures={procedure_archive} opk507={opk507} />
                </div>
                <div className="modal-footer">
                    <Button
                        className='btn-link'
                        color="wycena"
                        style={{width: '100%'}}
                        data-dismiss="modal"
                        type="button"
                        onClick={e => {
                            toggleArchiveModal()
                        }}>
                        Zamknij
                    </Button>
                </div>
            </Modal>

        </div>
    )
}
const mapStateToProps = state => ({
    materials:state.procedureDefReducer.materials,
    errorFileMaterial: state.procedureDefReducer.errorFileMaterial,
    loadingFileMaterial: state.procedureDefReducer.loadingFileMaterial,
    procedure_archive: state.ProcedurePricingReducer.procedure_archive,
    currentUser: state.UserReducer.currentUser

})
export default connect(mapStateToProps, {getCurrentUser, postProcedura, getTemplateExcelProcedury, uploadFileProcedury, getProcedures, getProcedureArchive, deleteProcedura})(Procedure)
